module.exports = __webpack_public_path__ + "static/media/PublicBgMid.449c4838.svg";